import { useState } from "react";
import { Delete, Plus, Trash2 } from "lucide-react";
import { fmt } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { inp } from "@/components/ui-kit";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "00", "0", ","];

export function NumPad({ lines, onChange, defaultVat }) {
  const { t } = useT();
  const [raw, setRaw] = useState("");
  const [name, setName] = useState("");
  const [qty, setQty] = useState(1);
  const [vat, setVat] = useState(defaultVat || 10);
  const price = raw ? +raw.replace(",", ".") : 0;
  const press = (k) => setRaw((r) => {
    if (k === "," ) return r.includes(",") ? r : (r || "0") + ",";
    const next = r + k;
    if (next.replace(",", "").length > 8) return r;
    if (r.includes(",") && next.split(",")[1].length > 2) return r;
    return next.replace(/^0+(?=\d)/, "");
  });
  const add = () => { if (price <= 0) return; onChange([...lines, { key: Date.now(), name: name.trim() || t("free_item"), price, qty: +qty || 1, vat_rate: +vat }]); setRaw(""); setName(""); setQty(1); };
  return (
    <div data-testid="numpad" className="grid gap-3 sm:grid-cols-[1fr_200px]">
      <div>
        <div className="mb-2 flex items-center justify-between rounded-2xl bg-slate-900 px-4 py-3 text-white">
          <span className="text-xs font-semibold uppercase text-slate-400">{t("amount")}</span>
          <span data-testid="numpad-display" className="font-heading text-3xl font-extrabold tabular-nums">€ {raw || "0"}</span>
        </div>
        <div className="grid grid-cols-3 gap-1.5">
          {KEYS.map((k) => <button key={k} type="button" data-testid={`numpad-key-${k === "," ? "comma" : k}`} onClick={() => press(k)} className="rounded-xl border border-slate-200 bg-white py-3 font-heading text-lg font-bold transition-colors hover:border-[#5aa469] hover:bg-[#5aa469]/10 active:scale-95">{k}</button>)}
          <button type="button" data-testid="numpad-key-back" onClick={() => setRaw((r) => r.slice(0, -1))} className="flex items-center justify-center rounded-xl border border-slate-200 bg-slate-50 py-3 hover:bg-slate-100"><Delete size={18} /></button>
          <button type="button" data-testid="numpad-key-clear" onClick={() => setRaw("")} className="rounded-xl border border-slate-200 bg-slate-50 py-3 text-sm font-bold hover:bg-slate-100">C</button>
          <button type="button" data-testid="numpad-add-btn" disabled={price <= 0} onClick={add} className="flex items-center justify-center gap-1 rounded-xl bg-[#5aa469] py-3 text-sm font-bold text-white disabled:opacity-40"><Plus size={16} />{t("add")}</button>
        </div>
        <div className="mt-2 grid grid-cols-[1fr_64px_84px] gap-2">
          <input data-testid="numpad-name-input" placeholder={t("free_item_desc")} className={inp} value={name} onChange={(e) => setName(e.target.value)} />
          <input data-testid="numpad-qty-input" type="number" min="1" className={inp} value={qty} onChange={(e) => setQty(e.target.value)} />
          <select data-testid="numpad-vat-select" className={inp} value={vat} onChange={(e) => setVat(e.target.value)}>{[4, 5, 10, 22].map((v) => <option key={v} value={v}>IVA {v}%</option>)}</select>
        </div>
      </div>
      <div className="flex flex-col rounded-2xl border border-slate-100 bg-[#f8fafc] p-3">
        <p className="mb-2 text-xs font-semibold uppercase text-slate-500">{t("free_lines")}</p>
        <ul className="flex-1 space-y-1.5 overflow-auto text-sm" data-testid="numpad-lines">
          {lines.length === 0 && <li className="text-slate-400">—</li>}
          {lines.map((l) => <li key={l.key} className="flex items-center justify-between gap-2 rounded-lg bg-white px-2 py-1.5">
            <span className="truncate">{l.qty}× {l.name} <span className="text-[10px] text-slate-400">{l.vat_rate}%</span></span>
            <span className="flex items-center gap-2 font-semibold">{fmt(l.price * l.qty)}<button data-testid={`numpad-line-remove-${l.key}`} onClick={() => onChange(lines.filter((x) => x.key !== l.key))} className="text-slate-400 hover:text-rose-600"><Trash2 size={14} /></button></span>
          </li>)}
        </ul>
        <p className="mt-2 border-t border-slate-200 pt-2 text-right font-heading font-extrabold" data-testid="numpad-lines-total">{fmt(lines.reduce((s, l) => s + l.price * l.qty, 0))}</p>
      </div>
    </div>
  );
}
